module.exports = __webpack_public_path__ + "media/images/rank/bronze-lg-6335b3a0cd575c125f7adad14ce42ac0.svg";